import { type ReactNode, useEffect, useState } from 'react'

interface ClientOnlyProps {
    children: ReactNode
    fallback?: ReactNode
}

/**
 * Wrapper component to render children only after hydration (client-side).
 * Prevents hydration mismatches for components that use browser-specific APIs
 * like window, localStorage, or timezone-dependent dates.
 */
export function ClientOnly({ children, fallback = null }: ClientOnlyProps) {
    const [mounted, setMounted] = useState(false)

    useEffect(() => {
        setMounted(true)
    }, [])

    return mounted ? <>{children}</> : <>{fallback}</>
}
